import { styled } from "@mui/material/styles";

export const VisibleOptionsText = styled("span")(() => ({
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "normal",
  lineHeight: "20px",
}));

export const VisibleOptionsContainer = styled("div")(() => ({
  display: "flex",
  maxWidth: "150px",
}));
